import React from "react";

const HMCSolo = () => {
  return (
    <svg
      width="40"
      height="47"
      viewBox="0 0 40 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9996 24.4404C10.7862 24.4404 2.94336 33.5085 2.94336 45.1998C2.94336 45.8902 2.38372 46.4498 1.69336 46.4498C1.003 46.4498 0.443359 45.8902 0.443359 45.1998C0.443359 32.5786 8.99423 21.9404 19.9996 21.9404C31.005 21.9404 39.5559 32.5786 39.5559 45.1998C39.5559 45.8902 38.9962 46.4498 38.3059 46.4498C37.6155 46.4498 37.0559 45.8902 37.0559 45.1998C37.0559 33.5085 29.213 24.4404 19.9996 24.4404Z"
        fill="url(#paint0_radial_441_6470)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9994 2.76245C18.2027 2.76245 16.4463 3.29524 14.9524 4.29344C13.4585 5.29165 12.2941 6.71043 11.6066 8.37039C10.919 10.0303 10.7391 11.8569 11.0896 13.6191C11.4401 15.3813 12.3053 17 13.5758 18.2705C14.8463 19.5409 16.4649 20.4061 18.2271 20.7566C19.9893 21.1072 21.8159 20.9273 23.4759 20.2397C25.1358 19.5521 26.5546 18.3878 27.5528 16.8938C28.551 15.3999 29.0838 13.6435 29.0838 11.8468V2.76245H19.9994ZM13.5635 2.21477C15.4685 0.941863 17.7082 0.262451 19.9994 0.262451H31.5838V11.8468C31.5838 14.138 30.9044 16.3777 29.6315 18.2828C28.3586 20.1878 26.5493 21.6726 24.4326 22.5494C22.3158 23.4262 19.9866 23.6556 17.7394 23.2086C15.4923 22.7616 13.4281 21.6583 11.808 20.0382C10.1879 18.4181 9.08462 16.354 8.63763 14.1068C8.19065 11.8597 8.42006 9.53045 9.29685 7.41368C10.1736 5.29691 11.6584 3.48768 13.5635 2.21477Z"
        fill="url(#paint1_radial_441_6470)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_441_6470"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(55.7305 71.8374) rotate(-137.414) scale(94.4412 253.797)"
        >
          <stop stopColor="#00B0CA" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_441_6470"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(41.165 47.4302) rotate(-124.286) scale(73.1177 183.562)"
        >
          <stop stopColor="#00B0CA" />
          <stop offset="1" stopColor="#9C2AA0" />
        </radialGradient>
      </defs>
    </svg>
  );
};

export default HMCSolo;
